import React, { Component } from 'react';
import { Marker, InfoWindow } from 'react-google-maps';

class PlaceMarker extends Component {
    state = {
        showInfoWindow: false
    };
    handleMouseOver = e => {
        this.setState({
            showInfoWindow: true
        });
    };
    handleMouseExit = e => {
        this.setState({
            showInfoWindow: false
        });
    };
    render() {
        const { showInfoWindow } = this.state;
        const { place } = this.props;
        return (
            <Marker position={this.props.position}
            icon={this.props.icon}
            onClick={()=>{}}
            onMouseOver=
                {this.handleMouseOver} onMouseOut={this.handleMouseExit}>
                {showInfoWindow && (
                    <InfoWindow>
                        <div>
                            <h5>{place.title}</h5>
                            <small>
                                <strong>Endereço: </strong>{place.formatted_address} <br />
                            </small>
                        </div>
                    </InfoWindow>
                )}
            </Marker>
        );
    }
}
export default PlaceMarker;
